





























import Vue from 'vue';
import { Component, Inject, Prop } from 'vue-property-decorator';

@Component
export default class Ico extends Vue {

    @Prop() payArr!: [{}];
    @Prop() earningArr!: [{}];
    @Inject() eventBus!: Vue;

    tab = '';
    selectedIco = 'eat';
    selectedText = '饮食'
    created() {
        this.eventBus.$on('updateSelectedTab', (tab: string) => {
            this.tab = tab;
        });
    }
    mounted(){
        this.eventBus.$on('reset',()=>{
            this.selectedIco = 'eat'
            this.selectedIco = '饮食'
        })
    }
    changeSelectedIco(name: string,text: string){
        this.$emit('updateSelectedIco', name, text)
        this.selectedIco = name;
        this.selectedText = text
    }

}
